@let sections = filteredSections();

<interacta-dialog
    [isOpen]="isOpen()"
    [size]="'extra-large'"
    [testId]="'useful-links-dialog'"
    (closing)="closeDialog()"
>
    <h2 class="typo-t4" title>
        {{ 'DIGITAL_WORKPLACE.USEFUL_LINKS' | translate }}
    </h2>
    @if (totalCount() > 20) {
        <interacta-input-search
            class="w-1/2"
            search
            [control]="search"
            [iconPosition]="'right'"
        />
    }
    <div
        class="mt-20 flex h-screen flex-col gap-y-24 overflow-x-hidden overflow-y-auto"
        content
    >
        <interacta-live-status [message]="searchResultsStatus()" />
        <!-- Mandatory isOpen check in order to destroy the dialog content: accordion content
            display problem due to animation bug when opening dialog more than one time -->
        @if (isOpen()) {
            @if (sections.length) {
                @for (section of sections; track section.id) {
                    <interacta-links-dialog-section
                        [isOpen]="sectionAccordionState()[section.id]"
                        [section]="section"
                        (linkActivated)="closeDialog()"
                        (loadError)="loadError.emit($event)"
                        (toggleAccordion)="toggleSection($event)"
                    />
                }
            } @else {
                <div class="flex grow items-center justify-center">
                    @let activeSearch = (search.value?.length ?? 0) > 0;
                    <interacta-no-result
                        [imageName]="activeSearch ? 'no-results' : 'empty-page'"
                        [subtitle]="
                            activeSearch
                                ? true
                                : ('USEFUL_LINK.EMPTY_DIALOG_SUBTITLE'
                                  | translate)
                        "
                        [title]="
                            (activeSearch
                                ? 'DIGITAL_WORKPLACE.NO_LINK'
                                : 'USEFUL_LINK.EMPTY_DIALOG_TITLE'
                            ) | translate
                        "
                    />
                </div>
            }
        }
    </div>
</interacta-dialog>
